<template>
  <div>
    <div>
      <v-img src="../assets/banner.jpg" height="550px"></v-img>
    </div>

    <product-panel
      background="#fff"
      font-color="#000"
      block-color="rgba(26,174,255,0.29)"
      :show-pagination="true"
      :datas="{products, services, equipments}"
      @page="handlePage"
    ></product-panel>
  </div>
</template>

<script>
import ProductPanel from '../components/ProductPanel.vue';
import { getProductList } from '../api/Product';

export default {
  components: { ProductPanel },

  data() {
    return {
      products: {
        data: [],
        extra: {
          total: 0,
          page: 1,
        },
      },
      services: {
        data: [],
        extra: {
          total: 0,
          page: 1,
        },
      },
      equipments: {
        data: [],
        extra: {
          total: 0,
          page: 1,
        },
      },
    };
  },

  beforeMount() {
    this.fetchProduct();
    this.fetchService();
    this.fetchEquipment();
  },

  methods: {
    handlePage(payload) {
      if (payload.type === 'products') {
        this.fetchProduct(payload.value);
      } else if (payload.type === 'services') {
        this.fetchService(payload.value);
      } else {
        this.fetchEquipment(payload.value);
      }
    },
    async fetchProduct(page = 1) {
      const { data: { data } } = await getProductList({ type: 1, page, limit: 2 });
      this.products = {
        ...data,
        extra: {
          ...data.extra,
          page: parseInt(data.extra.page, 10),
        },
      };
    },
    async fetchService(page = 1) {
      const { data: { data } } = await getProductList({ type: 2, page, limit: 2 });
      this.services = {
        ...data,
        extra: {
          ...data.extra,
          page: parseInt(data.extra.page, 10),
        },
      };
    },
    async fetchEquipment(page = 1) {
      const { data: { data } } = await getProductList({ type: 3, page, limit: 2 });
      this.equipments = {
        ...data,
        extra: {
          ...data.extra,
          page: parseInt(data.extra.page, 10),
        },
      };
    },
  },
};
</script>

<style lang="less" scoped>

</style>
